import { useEffect, useState } from "react";
import { getFileURL } from "../../../utils/GeneralUtils";

const SidebarIcon = ({ iconURL }) => {
  const [img, setImg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!iconURL || typeof iconURL !== "string") {
      setImg("");
      return setLoading(false);
    }

    if (
      (typeof iconURL === "string" && iconURL?.includes("http:")) ||
      iconURL?.includes("https:")
    ) {
      setImg(iconURL);
      return setLoading(false);
    }

    setLoading(true);

    getFileURL(iconURL)
      .then(
        (url) => setImg(url),
        (e) => setImg("")
      )
      .finally(() => setLoading(false));
  }, [iconURL]);

  return loading ? (
    <div
      className="skeleton"
      style={{
        position: "absolute",
        transform: "translate(0, -50%)",
        top: "50%",
        left: 3,
        height: 16,
        width: 16,
      }}
      alt="Icon"
    />
  ) : img ? (
    <img
      src={img}
      style={{
        width: "100%",
        position: "absolute",
        transform: "translate(0, -50%)",
        top: "50%",
      }}
      alt="Icon"
      className="pr-2 "
    />
  ) : (
    <i
      className={`mdi mdi-file-table-box-outline pr-2`}
      style={{ fontSize: 18 }}
    />
  );
};

export default SidebarIcon;
